import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=18cd86a4&"
import script from "./Change.vue?vue&type=script&lang=js&"
export * from "./Change.vue?vue&type=script&lang=js&"
import style0 from "./Change.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports